module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/pingpong-icon-e8535cea7c7e89c4343775510ea4db04.png";